import { useEffect, useState } from "react";
import { LedgerRecord } from "../../../services/interface";
import { getLedger } from "src/shared/services/servicesv2";

export function useLedgerSearch(includeSettled: boolean = true) {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState<LedgerRecord[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const delay = setTimeout(async () => {
      const trimmedSearch = searchTerm.trim();

      // Empty or only-space search
      if (!trimmedSearch) {
        setResults([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        const res = await getLedger(
          1, // page
          20, // pageSize
          trimmedSearch, // search
          "", // sortField
          "", // sortOrder
          includeSettled, // includeSettled
        );

        const ledgerData = res?.data?.result || res?.data?.results || res?.data?.data || [];

        setResults(Array.isArray(ledgerData) ? ledgerData : []);
      } catch (error) {
        console.error("Error fetching ledgers:", error);

        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [searchTerm, includeSettled]);

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  return {
    searchTerm,
    results,
    loading,
    setSearchTerm: handleSearchChange,
  };
}
